export const paginationSize = "22px";
